import { useEffect, useRef, useState } from "react";
import PdpService, {errorMessage} from "../../services/PdpService";
import {usePdpPermissions} from "../../hooks/usePdpPermissions";
import "./PdpDocumentControl.scss";
export default function PdpDocumentControl({driverId,readOnly=false}:{driverId:number;readOnly?:boolean}) {
  const {canManagePdp}=usePdpPermissions();
  const [present,setPresent]=useState(false);const [error,setError]=useState("");const [busy,setBusy]=useState(false);
  const [loading,setLoading]=useState(true);const [uploaded,setUploaded]=useState("");const input=useRef<HTMLInputElement>(null);
  useEffect(()=>{const c=new AbortController();setLoading(true);setPresent(false);setUploaded("");setError("");
    PdpService.documentInfo(driverId,c.signal).then(info=>{if(!c.signal.aborted)setPresent(info.present);})
      .catch(e=>{if(!c.signal.aborted)setError(errorMessage(e));}).finally(()=>{if(!c.signal.aborted)setLoading(false);});
    return ()=>c.abort();},[driverId]);
  async function upload(file?:File){
    if(!file)return;
    if(file.size===0 || file.size>5*1024*1024 || !file.name.toLowerCase().endsWith(".pdf")){setError("Select a PDF file up to 5 MB.");return;}
    setBusy(true);setError("");
    try{await PdpService.uploadDocument(driverId,file);setPresent(true);setUploaded(file.name);if(input.current)input.current.value="";}
    catch(e){setError(errorMessage(e));}finally{setBusy(false);}
  }
  async function download(){setBusy(true);setError("");try{await PdpService.downloadDocument(driverId);}catch(e){setError(errorMessage(e));}finally{setBusy(false);}}
  const canUpload=!readOnly && canManagePdp;
  return <div className="form-group pdp-doc">
    <div className="pdp-doc__head">
      <h4>PDP PDF document</h4>
      <span className={`pdp-doc__badge ${present?"pdp-doc__badge--ok":""}`}>{loading?"Checking...":present?"Attached":"Not uploaded"}</span>
    </div>
    <p className="pdp-doc__text">{loading?"Checking document...":present?"A PDP PDF is attached.":"No PDP PDF uploaded."}{uploaded && !busy && <span className="pdp-doc__file"> Uploaded: {uploaded}</span>}</p>
    <div className="pdp-doc__actions">
      {present && <button type="button" className="pdp-doc__btn" disabled={busy || loading} onClick={download}>Download PDP PDF</button>}
      {canUpload && <label className={`pdp-doc__btn pdp-doc__btn--primary ${busy||loading?"is-disabled":""}`}>
        {busy?"Uploading...":present?"Replace PDF":"Upload PDF"}
        <input ref={input} className="pdp-doc__input" aria-label="Upload PDP PDF" type="file" accept="application/pdf,.pdf" disabled={busy || loading} onChange={e=>upload(e.target.files?.[0])}/>
      </label>}
    </div>
    {canUpload && <span className="pdp-doc__help">PDF only, up to 5 MB. The file uploads as soon as you choose it and is saved separately from the details above.</span>}
    {busy && <p className="pdp-doc__status" role="status">Saving or downloading document...</p>}{error && <p className="pdp-doc__error" role="alert">{error}</p>}
  </div>;
}
